
























import {Component, Prop, Provide} from "vue-property-decorator";
import {LadingStore} from "@/modules/ladings/store";
import LadingSearch from "@/modules/ladings/List/components/Search.vue";
import LadingTableAction from "@/modules/ladings/List/components/TableAction.vue";
import moment from 'moment';
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import DetailLadingPrint from "@/modules/ladings/Print/components/Detail.vue";
import {Options} from "@/plugins/print/lib/print";
import {getPublicPath, getValidQuery} from "@/shared/services/helper/utils";
import {LadingParams} from "@/modules/ladings/params";
import LadingTable from "@/modules/ladings/List/components/Table.vue";
import {LadingStatus} from '@/enums/status';
import LadingPrintBill from "@/modules/ladings/Print/Bill/index.vue";
import PrintLading from "@/modules/ladings/Print/index.vue";
import TableToExcel from "@linways/table-to-excel";
import ManageLadingExcel
  from "@/modules/ladings/List/components/ManageLadingExcel/index.vue";
import { FORMAT_DATE_PICKER } from '@/shared/constant';


@Component({
    name: "LadingList",
    components: {
        PrintLading,
        LadingPrintBill, LadingTable, DetailLadingPrint, LadingStatusLabel, LadingTableAction, LadingSearch,
      ManageLadingExcel
    }
})
export default class extends mixins(CommonMixin) {

    @Prop() query!: any;
    visibleModal = false;
    @Provide() routingEdit = true;
    moment = moment;
  FORMAT_DATE_PICKER = FORMAT_DATE_PICKER;
  params = new LadingParams();
  exceptStatus = [
        LadingStatus.GdKhoiTao,
        LadingStatus.LayHangThanhCong,
        LadingStatus.LayHangThanhCongChoCapNhat,
        LadingStatus.ChoLayHang,
        LadingStatus.ChoCapNhat
    ];
  isExporting = false;
  selectedRowLadings: string[] = [];
    printObj: Options = {
        id: 'print-lading-list',
        popTitle: 'Logistic',
        extraCss: `${getPublicPath()}assets/css/print.css`
    };

    created() {
        // const statusString = difference(getValuesEnum(LadingStatus), this.exceptStatus).join(",");

        // let params = {...new LadingParams()};
        // if (this.query) {
        //     params = { ...params, ...getValidQuery(this.query) };
        // }
        LadingStore.updateLadingParams(this.params);
        LadingStore.listLading(this.params)
    }
  async exportExcel() {
    this.isExporting = true;
    await LadingStore.exportExcelLading({...this.params, limit: 300});
    this.isExporting = false;
    setTimeout(() => {
      TableToExcel.convert(document.getElementById("table-excel-lading"), {
        name: `Danh sách đơn.xlsx`,
        sheet: {
          name: "Sheet 1"
        }
      }, 800);
    })
  }
    printLadings() {
        this.$print(this.printObj);
    }
}
